import axios from "./_axios";
import { API } from "./apiEndPoints";

/**
 * Job Category Scoring — account-level scoring configuration (ER-11785).
 *
 * The account's Job Value Bands are derived from `band_count` on this row
 * (ER-11783); there are no band CRUD endpoints any more. Routes follow the
 * same account-scoped v2 convention as job-category/ and job-family/ (see
 * jobCategoryAPI.js / jobFamilyAPI.js).
 */

function jobScoringConfigUrl(accountId) {
  return `${API.ACCOUNT_LIST_V2}${accountId}/${API.JOB_SCORING_CONFIG}`;
}

/**
 * GET /api/common/v2/account/<id>/job-scoring-config/
 * Returns the account's single scoring configuration, including the read-only
 * factor weighting table, the Total Score scale and the configured band count.
 */
export const getJobScoringConfig = (accountId) => {
  return axios()({
    method: "get",
    url: jobScoringConfigUrl(accountId),
  });
};

/**
 * PUT /api/common/v2/account/<id>/job-scoring-config/
 * Replaces the configuration. Payload: { band_count } (2-10). The factor
 * weighting is inherited from EIGE and is not writable.
 */
export const updateJobScoringConfig = (accountId, data) => {
  return axios()({
    method: "put",
    url: jobScoringConfigUrl(accountId),
    data,
  });
};
